import { UseProductivityRiskKPIProvider } from 'components/widgets/ProductivityRiskKPI/ProductivityRiskKPI.provider';
import { getValueClassName } from 'components/widgets/ProductivityRiskKPI/ProductivityRiskKPI.utils';

interface Props {
    api: UseProductivityRiskKPIProvider['api'];
}

export const useProductivityRiskKPILogic = ({ api }: Props) => {
    const value = api.getProductivityRiskKPI.instance.data?.value;
    const threshold = api.getProductivityRiskKPI.instance.data?.threshold;

    const calculatedValue = api.getProductivityRiskKPI.instance.data?.value
        ? api.getProductivityRiskKPI.instance.data?.value
        : 'N/A';

    return {
        logic: {
            valueClassName: getValueClassName(value, threshold),
            calculatedValue,
        },
    };
};
